function unique<TYPE>(a: TYPE[]): TYPE[] {
    return a.filter(function (item, pos) {
        return a.indexOf(item) == pos
    })
}

export default unique
